/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
/* global fetch, localStorage */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import moment from 'moment';
import { endpoint } from '..';
import { UPLOAD_MEDICAL_CERTIFICATE_REQUEST, success, failure } from './action';

const events = (action$) =>
  action$
    .ofType(UPLOAD_MEDICAL_CERTIFICATE_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ personId, medicalCertificate, medicalCertificateDate }) => {
      const formData = new FormData();

      formData.append('file', medicalCertificate);
      formData.append('medicalCertificateDate', moment(medicalCertificateDate, 'DD/MM/YYYY'));

      return Observable.fromPromise(
        fetch(`${endpoint}/admin/personcustom/people/${personId}/uploadmedicalcertificate`, {
          method: 'post',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authenticationToken')}`,
          },
          body: formData,
        }),
      )
        .map((response) => {
          switch (response.status) {
            case 500:
              throw new Error('Internal Server Error');
            case 400:
              throw new Error('Bad Request');
            default:
              break;
          }
          return true;
        })
        .mergeMap((response) => Observable.of(success(response)))
        .catch((err) => Observable.of(failure(err)));
    });

export default combineEpics(events);
